// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"5e33902a","247":"7b6aebd3","627":"d104ca49","653":"edfc13a4","834":"c2798794","867":"a2d4b54c","923":"208e13ea","938":"a6837f6f"}[chunkId] + ".chunk.js";
};